import gql from 'graphql-tag';

export const GetAllRoutineTemplates = gql`
	query RoutineTemplates($pk: UUID) {
		routineTemplates(pk: $pk) {
			category
			description
			excludeWeekends
			interval
			isDeleted
			monthSetup
			name
			organizationPsId
			period
			pk
			priority
			selectedDays
			template
			updated
			created
		}
	}
`;
